<div class="subsidy-program-container d-flex flex-column">
    <div class="subsidy-program-content">
        <div [formGroup]="subsidyProgramForm" trackChanges>
            <div class="row col-sm-6">
                <div class="col-sm-3">
                    <label class="mt-2">{{ 'SUBSIDY_DOLLARS' | translate }}:</label>
                </div>
                <div class="col-sm-2"></div>
                <div class="col-sm-2">
                    <mat-form-field appearance="outline" class="col-sm-12" [class.readonly-field]="isReadOnly">
                        <input matInput [readonly]="isReadOnly" [appNumericMask]= "subsidyDollarsConfig" class="text-end" placeholder="0.00" formControlName="subsidyDollars">
                </mat-form-field>
                </div>
            </div>
            <div class="row col-sm-6">
                <div class="col-sm-3">
                    <label>{{ 'APPLY_TO' | translate }}:</label>
                </div>
                <div class="col-sm-4">
                    <mat-form-field appearance="outline" class="col-sm-12" [class.readonly-field]="isReadOnly">
                        <mat-select formControlName="applyToDropdown" [disabled]="isReadOnly">
                            @for (itr of applyToList; track itr.id) {
                                <mat-option class="optionHeight" [value]="itr.id">{{itr.description}}</mat-option>
                            }
                        </mat-select>
                    </mat-form-field>
                </div>
            </div>
        </div>
    </div>
    <div class="subsidy-program-footer d-flex justify-content-end">
        @if (showApplyBtn) {
            <button mat-raised-button color="primary" [disabled]="!enableApplyBtn() || isReadOnly" (click)="onApply()">{{ 'APPLY' | translate
            }}</button>
        }
        @if (!showApplyBtn) {
            <button mat-raised-button color="primary" (click)="onRemove()" [disabled]="isReadOnly">{{ 'REMOVE' | translate }}</button>
        }
        <button mat-raised-button color="warn" (click)="onClose()">{{ 'CLOSE' | translate }}</button>
    </div>
</div>